"use client"
import React, { useState } from 'react'
import { Tabs, Tab } from "react-bootstrap";
import { Container, Row, Col, Image } from "react-bootstrap";
import VigilanceNav from './VigilanceNav';
import { useTheme } from '@/app/theme-provider';
const InnerPageBanner = ({ pageName, vigilance, downloads, orders, awards, wings, complaintstatus, contactus,albums,pageNameMalayalam }) => {
  const [key, setKey] = useState("about");
  const {
      theme,
      toggleTheme,
      toggleHighlightLinks,
      highlightLinks,
      language,
      toggleLanguage,
    } = useTheme();

  return (
    <>
      <>
        <div className='inner-banner-white'>
          <h5>{language=="en"?pageName:pageNameMalayalam?pageNameMalayalam:pageName}</h5>
        </div>
        <div className="breadcrumb-container mt-3">
          <nav className="breadcrumb">
            <a href="/" className="active">{language=="en"?"Home":"ഹോം"}</a>
            <span className="separator">›</span>
            {downloads ? (
              <>
                <span >{language=="en"?"Downloads":"ഡൗൺലോഡുകൾ"}</span>
                <span className="separator">›</span>
              </>
            ) : null}
            {vigilance ? (
              <>
                <span>{language=="en"?"Vigilance":"വിജിലൻസ്"}</span>
                <span className="separator">›</span>
              </>
            ) : null}
            {wings ? (
              <>
                <span>{language=="en"?"Wings":"വിഭാഗം"}</span>
                <span className="separator">›</span>
              </>
            ) : null}
            {awards ? (
              <>
                <span>{language=="en"?"Awards":"അവാർഡുകൾ"}</span>
                <span className="separator">›</span>
              </>
            ) : null}
            {contactus ? (
              <>
                <span>{language=="en"?"Contact us":"സമ്പർക്കം"}  </span>
                <span className="separator">›</span>
              </>
            ) : null}

             {albums ? (
              <>
                <span>{language=="en"?"Albums":"ആൽബങ്ങൾ"}   </span>
                <span className="separator">›</span>
              </>
            ) : null}
            <span>{language=="en"?pageName:pageNameMalayalam?pageNameMalayalam:pageName}</span>
            {orders ? (
              <>
                <span className="separator">›</span>
                <span>{orders}</span>
              </>
            ) : null}

          </nav>
        </div>
      </>
    </>
  )
}

export default InnerPageBanner
